<template>
  <div
    class="divide-y divide-gray-200 border border-gray-200 rounded-md group relative"
  >
    <div class="p-4 font-medium flex justify-between items-center">
      <div class="text-headline">{{ table.title ?? "" }}</div>
      <button @click="showEditModal = true">
        <icon-base :icon="IconEdit" />
      </button>
    </div>
    <div v-if="table.fields.length" class="p-4 gap-2 flex flex-wrap">
      <lf-tag v-for="field in table.fields" :key="field.id">
        {{ field.label }}
      </lf-tag>
    </div>
    <div
      v-tooltip="$t('OFFER_CUSTOMISATION.REMOVE_FIELD')"
      class="absolute top-1/2 right-0 z-100 flex h-4 w-4 translate-x-1/2 transform cursor-pointer items-center justify-center rounded-full bg-gray-400 opacity-0 transition-opacity group-hover:opacity-100"
      @click.prevent="removeField"
    >
      <icon-base
        :icon="IconX"
        height="10"
        width="10"
        viewBox="0 0 16 16"
        class="-mt-[2px] text-white"
      />
    </div>
    <checkout-data-table-edit-modal
      v-if="showEditModal"
      :table
      @close="showEditModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import IconEdit from "@/components/icons/IconEdit.vue";
import IconX from "@/components/icons/deals/IconX.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfTag from "@/components/ui/text/LfTag.vue";
import CheckoutDataTableEditModal from "@/views/checkout/components/CheckoutDataTableEditModal.vue";

import type { CheckoutDataTable } from "@/models/checkout";

const { table } = defineProps<{
  table: CheckoutDataTable;
}>();

const emit = defineEmits<{
  deleteField: [];
}>();

const showEditModal = ref(false);

const removeField = () => {
  emit("deleteField");
};
</script>
